export const getStyles = () => ({
  searchBoxContainer: {
    '& .bing-maps-search-box-dropdown': {
      display: 'block',
      width: '420px',

      '& .bing-maps-search-box-results-menu': {
        minWidth: '100%',
        maxWidth: '100%',
      },

      '& .bing-maps-search-box-search-result': {
        width: '100%',
        display: 'table',
        lineHeight: '20px',
        padding: '8px 0 8px 0',

        '& .bing-maps-search-box-search-result-name': {
          display: 'table-cell',
          whiteSpace: 'normal',
        },

        '& .bing-maps-search-box-search-result-buttons': {
          display: 'table-cell',
          verticalAlign: 'top',
          textAlign: 'right',
          paddingLeft: '8px',
        },

        '& .bing-maps-search-box-search-result-already-exists': {
          color: '#605e5c',
        },
      },

      // override some of the default bootstrap dropdown styling
      '& .dropdown-menu > div > li > a': {
        height: 'auto',
        padding: '0px 8px !important',
      },
    },
  },
});

export const getSearchOptionsStyles = (_, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  inlineHelp: {
    marginLeft: '3px',
    fontSize: '15px !important',
    fontWeight: 'normal',

    '& .helpbutton': {
      paddingTop: '2px',
      paddingLeft: '2px',

      '&::before': {
        content: '"\\E9CE"',
        fontFamily: iconFontFamily,
        position: 'relative',
        color: palette.themePrimary,
        verticalAlign: 'middle',
      },

      '&:focus': {
        outline: '1px solid',
        outlineColor: palette.neutralSecondary,
        border: 'none',
        color: palette.black,
        textDecoration: 'none',
      },

      '&:hover': {
        backgroundColor: palette.neutralLighter,
        color: palette.black,
        textDecoration: 'none',
      },

      '&:active': {
        backgroundColor: palette.neutralLight,
        color: palette.black,
        textDecoration: 'none',
      },
    },
  },
  bingMapsSearchBoxAndAddBulkButton: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    '& .add-in-bulk-button': {
      whiteSpace: 'nowrap',
      minWidth: '145px',
      padding: '0 4px',
      border: 'none',
    },
  },
});
